import { AppData, Lightning } from '@lightningjs/sdk';
import AbstractLoginModal, {
  AbstractLoginModalTemplateSpec,
  LoginFlow,
} from '../layout/AbstractLoginModal';
import CreatePasswordContent from './CreatePasswordContent';
import { reportSignUpPassword } from 'services/analytics/reportingServicePage';

export interface CreatePasswordModalTemplateSpec
  extends AbstractLoginModalTemplateSpec {
  Content: {
    CreatePasswordContent: typeof CreatePasswordContent;
  } & AbstractLoginModalTemplateSpec['Content'];
}

export default class CreatePasswordModal
  extends AbstractLoginModal
  implements
    Lightning.Component.ImplementTemplateSpec<CreatePasswordModalTemplateSpec>
{
  override _showBackButton = true;

  override get loginFlow() {
    return LoginFlow.SIGN_UP;
  }

  private _CreatePasswordContent = this._Content.getByRef(
    'CreatePasswordContent',
  );

  static override _template(): Lightning.Component.Template<CreatePasswordModalTemplateSpec> {
    const { Content, ...rest } = super._template();
    return {
      Content: {
        ...Content,
        h: 1080,
        flex: {
          direction: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        CreatePasswordContent: {
          type: CreatePasswordContent,
          signals: {
            $onContentHovered: true,
            $onSubmitRegistration: true,
            $openKeyboard: '$openKeyboard',
            $resetToEmailInput: true,
          },
        },
      },
      ...rest,
    };
  }

  modalInit(data: { email: string }) {
    this._CreatePasswordContent.email = data?.email;
  }

  private $onContentHovered() {
    this._setState('Content');
  }

  private async $onSubmitRegistration(args: {
    email: string;
    password: string;
    optIn: boolean;
  }) {
    const success = await this.onLoading(
      AppData!.loginRadiusService!.registerEmail(
        args.email,
        args.password,
        args.optIn,
      ),
    );

    if (success) {
      // Track sign up with password analytics
      reportSignUpPassword(args.email, args.optIn, this._pageId);
      AppData?.modalService.open('SignInConfirmationModal');
    }
  }

  override _getFocused() {
    return this._CreatePasswordContent;
  }
}
